import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { SM, LG } from '@zendeskgarden/react-typography';
import { Grid, Col, Row } from '@zendeskgarden/react-grid';
import { size, map, join } from 'lodash';
import Flex from 'styled-flex-component';

import DocumentDownload from 'components/DocumentDownload/DocumentDownload';
import AlloyComposition from 'components/AlloyComposition/AlloyComposition';
import { alloySynonymMap, attributeMap } from 'utility/staticMap.ts';
import { titleCase } from 'utility/formatStrings';
import {
  AttributeCardRedesign,
  AttributeCol,
  AttributeRowRedesign,
  FileWrapper,
  HeroCard,
  HeroDescription,
  HeroTitle,
} from './CategoryAlloyHero.styles';

function CategoryAlloyHeroRedesign({
  groupName,
  alloyName,
  alloyDetails,
  files,
}) {
  const renderAlloyCompositionTitle = useCallback(
    () => (
      <LG slate style={{ marginBottom: '5px' }}>
        Elemental Composition
      </LG>
    ),
    []
  );

  const synonyms = alloySynonymMap[alloyName]?.synonyms;

  return (
    <>
      <HeroCard>
        <Flex
          column
          justifyCenter
          style={{
            minHeight: '160px',
          }}
        >
          <Grid>
            <Row justifyContent="between" alignItems="center">
              <Col xs={12} sm={6}>
                <Flex
                  column
                  justifyCenter
                  style={{
                    height: '100%',
                  }}
                >
                  <HeroTitle>
                    {alloyName
                      ? `${groupName}: ${alloyName}`
                      : titleCase(groupName)}
                  </HeroTitle>
                  <HeroDescription
                    slate
                    style={synonyms && { minHeight: '50px' }}
                  >
                    {!!synonyms && join(synonyms, ', ')}
                  </HeroDescription>
                </Flex>
              </Col>
            </Row>
          </Grid>
        </Flex>
      </HeroCard>
      {alloyDetails && !!size(alloyDetails) && (
        <Grid style={{ margin: '20px 0' }}>
          <AttributeRowRedesign>
            {map(attributeMap, (attribute) => {
              const range = `${alloyDetails[attribute.minKey]} - ${
                alloyDetails[attribute.minKey]
              }`;
              const value = alloyDetails[attribute.key];
              if (
                value ||
                alloyDetails[attribute.minKey] ||
                alloyDetails[attribute.minKey]
              ) {
                return (
                  <AttributeCol key={attribute.label}>
                    <AttributeCardRedesign>
                      <SM style={{ textAlign: 'center' }}>{attribute.label}</SM>
                      <SM slate style={{ textAlign: 'center' }}>
                        {attribute.isRange ? range : value}
                      </SM>
                    </AttributeCardRedesign>
                  </AttributeCol>
                );
              }
              return null;
            })}
          </AttributeRowRedesign>
        </Grid>
      )}
      {alloyDetails && (
        <AlloyComposition
          data={alloyDetails}
          renderTitle={renderAlloyCompositionTitle}
        />
      )}
      {files && files.length ? (
        <div style={{ marginTop: '30px', marginBottom: '30px' }}>
          <Row>
            <Col size="auto">
              <LG slate style={{ marginBottom: '5px' }}>
                Additional Documentation
              </LG>
              <Flex wrap="wrap">
                {map(files, (file) => {
                  const title = file?.original_file_name;
                  const fileId = file?.id;
                  return (
                    <FileWrapper key={file?.id}>
                      <DocumentDownload
                        style={{ background: '#fff' }}
                        disableDelete
                        documentItem={{ title, fileId }}
                        legacy
                      />
                    </FileWrapper>
                  );
                })}
              </Flex>
            </Col>
          </Row>
        </div>
      ) : (
        <div style={{ marginBottom: '30px' }} />
      )}
    </>
  );
}

CategoryAlloyHeroRedesign.propTypes = {
  groupName: PropTypes.string,
  alloyName: PropTypes.string,
  alloyDetails: PropTypes.shape({}),
  files: PropTypes.arrayOf(PropTypes.shape({})),
  categories: PropTypes.shape({
    result: PropTypes.shape({
      total: PropTypes.number,
    }),
  }),
};

export default CategoryAlloyHeroRedesign;
